export const setCURRENTREQUESTOBJECT = "setCURRENTREQUESTOBJECT";

export const resetCURRENTREQUESTOBJECT = "resetCURRENTREQUESTOBJECT";
